export default {
  SET_ONGOING_ACTIVITIES (state, activities) {
    state.ongoingActivities = activities
  },
  SET_ONGOING_ACTIVITIES_FETCHED (state, value) {
    state.ongoingActivitiesFetched = value
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/global/mutations.js